import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSingleProduct } from '../../../../redux/slices/hyperwolf/products';
import ProductDetailsPage from 'components/hyperwolf/products/ProductDetails';

export default function HyperwolfProductDetails() {
  const dispatch = useDispatch();
  const { productId = '' } = useParams();
  useEffect(() => {
    if (productId) {
      dispatch(fetchSingleProduct(productId));

    }
  }, [productId]);
  return (
    <CommonLayout>
      <ProductDetailsPage/>
    </CommonLayout>
  );
}